import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { Switch } from "antd";
import _ from "lodash";

import ModalComponent from "components/modalComponent/ModalComponent";

class ModalSectorsManagementContent extends PureComponent {
  updateSector = switchStatus => {
    const { onChangeSwitchSectorsManagement, sector } = this.props;

    onChangeSwitchSectorsManagement(sector.sector_id, switchStatus);
  };

  render() {
    const { sector, checked, currentClientLabel } = this.props;

    return (
      <div className="p-al-full p-mrg-ver">
        <span>
          {sector.sector_label} ({sector.client_label})
        </span>
        <Switch checked={checked} onChange={switchStatus => this.updateSector(switchStatus)} />
      </div>
    );
  }
}

class ModalSectorsManagement extends PureComponent {
  render() {
    const {
      user,
      showModal,
      closeModal,
      userSectors,
      sectorsList,
      onChangeSwitchSectorsManagement,
      currentClientLabel,
      currentClient,
      userClients
    } = this.props;
    const userSectorsList = userSectors.map(userSector => userSector.sector_id);
    const userClientsLabelList = userClients.map(client => client.label);

    return (
      <ModalComponent
        title={`GESTION DES SECTEURS POUR LE CLIENT ${currentClientLabel}`}
        showModal={showModal}
        closeModal={closeModal}
        {...this.props}
      >
        <div className="p-mrg-bot-l p-clr-mdg">{user.email}</div>

        {_.isEmpty(sectorsList) ? (
          <div>Pas de sectorisation pour le dossier {currentClientLabel}</div>
        ) : !userClientsLabelList.includes(currentClientLabel) ? (
          <div>Cet utilisateur n'est pas lié au dossier {currentClientLabel}</div>
        ) : (
          sectorsList.map((sector, i) => (
            <ModalSectorsManagementContent
              key={i}
              sector={sector}
              currentClientLabel={currentClientLabel}
              onChangeSwitchSectorsManagement={onChangeSwitchSectorsManagement}
              checked={userSectors.some(v=>v.sector_id === sector.sector_id && v.client_id === sector.client_id)}
            />
          ))
        )}
      </ModalComponent>
    );
  }
}

ModalSectorsManagementContent.propTypes = {
  client: PropTypes.object,
  onChangeSwitchSectorsManagement: PropTypes.function
};

ModalSectorsManagement.propTypes = {
  showModal: PropTypes.boolean,
  closeModal: PropTypes.function,
  userClients: PropTypes.array,
  clientsList: PropTypes.array,
  currentClient: PropTypes.object,
  onChangeSwitchSectorsManagement: PropTypes.function
};

export default ModalSectorsManagement;



// WEBPACK FOOTER //
// src/containers/admin/users/ModalSectorsManagement.js